import { createAsyncThunk } from '@reduxjs/toolkit';
import { modelosDecursoService } from './services';
import type { ListModelosResult } from '@/features/modelos-documento/api';

export const listarModelosDecurso = createAsyncThunk<
  ListModelosResult,
  number,
  { rejectValue: string }
>('modelosDecurso/listar', async (page, { rejectWithValue }) => {
  try {
    return await modelosDecursoService.listar(page);
  } catch (error) {
    return rejectWithValue(error instanceof Error ? error.message : 'Erro ao carregar os modelos.');
  }
});
